import Product1 from "../assets/images/product-1.png"
import Product2 from "../assets/images/product-2.png"
import Product3 from "../assets/images/product-3.png"
import Product4 from "../assets/images/product-4.png"
import JewelleryMegaMenu from "../components/front/JewelleryMegaMenu"
import GemellryWorldMegaMenu from "../components/front/GemellryWorldMegaMenu"


export const HeaderMegaMenuNavigation = [
    { actionLink: "Gemellry World",arText:"عالم المجوهرات", hasSubMenu: true, menuComponent: <GemellryWorldMegaMenu /> }
]

export const newArrives = [
    {
        title: "Buy Designers Earrings"
    }
]

export const productCategories = [
    "Earrings",
    "Pendants",
    "Rings",
    "Neckwear",
    "Bangles",
    "Bracelets"
]
export const arrivalsSpan = [
    "Poppular",
    "New"
]

export const products = [
    {
        productImg: Product1,
        title: "Eternity Ring In 18K White Gold With Brilliant-Cut Diamonds, 6.59cts"
    },
    {
        productImg: Product2,
        title: "Eternity Ring In 18K White Gold With Brilliant-Cut Diamonds, 6.59cts"
    },
    {
        productImg: Product3,
        title: "Eternity Ring In 18K White Gold With Brilliant-Cut Diamonds, 6.59cts"
    },
    {
        productImg: Product4,
        title: "Eternity Ring In 18K White Gold With Brilliant-Cut Diamonds, 6.59cts"
    },
    {
        productImg: Product1,
        title: "Eternity Ring In 18K White Gold With Brilliant-Cut Diamonds, 6.59cts"
    },
    {
        productImg: Product2,
        title: "Eternity Ring In 18K White Gold With Brilliant-Cut Diamonds, 6.59cts"
    },
    {
        productImg: Product3,
        title: "Eternity Ring In 18K White Gold With Brilliant-Cut Diamonds, 6.59cts"
    },
    {
        productImg: Product4,
        title: "Eternity Ring In 18K White Gold With Brilliant-Cut Diamonds, 6.59cts"
    }
]

export const Categories =[
    {text:"Earrings",id:Math.random()},
    {text:"Rings",id:Math.random()},
    {text:"Bracelates   ",id:Math.random()},
    {text:"Necklaces",id:Math.random()},
    {text:"Anklets",id:Math.random()},
]
export const Stone =[
    {text:"Pink Coral",id:Math.random()},
    {text:"Diamond ",id:Math.random()},
    {text:"Diamond",id:Math.random()}
]
export const Gold = [
    { text: "Yellow Gold", id: Math.random(), value: "yellow_gold", ar_text: "الذهب الأصفر" },
    { text: "White Gold", id: Math.random(), value: "white_gold", ar_text: "ذهب ابيض" },
    { text: "Rose Gold", id: Math.random(), value: 'rose_gold', ar_text: "وارتفع الذهب" },
    { text: "Blue", id: Math.random(), value: 'blue', ar_text: "أزرق" },
    { text: "Green", id: Math.random(), value: 'green', ar_text: "أخضر" },
    { text: "Purple", id: Math.random(), value: 'purple', ar_text: "بنفسجي" },
    { text: "Pink", id: Math.random(), value: 'pink', ar_text: "وردي" },
    { text: "Yellow", id: Math.random(), value: 'yellow', ar_text: "أصفر" },
    { text: "Bronze", id: Math.random(), value: 'bronze', ar_text: "برونزي" },
]
export const productType =[
    {text:"Bracelate",id:Math.random()}
]
export const SortBy =[
    // {text:"RelevancePrice",id:Math.random(),value:""},
    {text:"low to high Price",id:Math.random(),value:1,ar_text:"السعر من الأقل للأعلى"},
    {text:"High To Low Price",id:Math.random(),value:-1,ar_text:"السعر من الأعلى للأقل"}
]

// export const products = ""